import React from 'react';
import GigComponent from './GigComponent'
import Loading from '../Loading';
import { observer } from "mobx-react-lite"
import AppState from '../../AppState';
import { File } from '../FileList/types';

interface Props {
    state: AppState
}

const GigList = observer(({state}: Props) => {

    return (
        <Loading loading={state.gigsLoading}>
            <h6>
                Keikat
                {
                    state.config.admin ? 
                        <button className="success inline" onClick={() => state.setGigToEdit({})}>Lisää keikka</button> : null
                }
            </h6>

            <div className="gig-list">
                { state.gigs.map(gig => 
                    <GigComponent 
                        key={"gig-" + gig.id} gig={gig} 
                        config={state.config} 
                        setEditGig={() => state.setGigToEdit(gig)} 
                        pushFile={(file: File) => state.pushGigFile(gig, file)}
                        removeFile={(file: File) => state.removeGigFile(gig, file)}
                        />
                        ) }
                { !state.gigs.length ? <p>Ei oo ny keikkoja</p> : null }
            </div>
        </Loading>
    );
})

export default GigList